module.exports = __webpack_public_path__ + "static/media/icon-on-side.1999ce5d.svg";